import React from 'react';

export const Subheader = ({ title, count, extra, h2class }) => {
    return (
        <div className="flex flex-center mb10" style={{ minHeight: '36px' }}>
            <h2 className={`${h2class || ''} flex-grow`}>
                {title}
                {count !== undefined && (
                    <span className="ml10" style={{ fontWeight: 400 }}>
                        {count}
                    </span>
                )}
            </h2>
            {extra && <div className="text-right">{extra}</div>}
        </div>
    );
};

export default Subheader;
